import { NgModule } from '@angular/core';
import { LocaleRoutingModule } from './locale-routing.module';

@NgModule ({
    imports: [
        LocaleRoutingModule
    ],
    declarations: [
    ],
    exports: [
    ]
})
export class LocaleModule {

}
